package com.dotdrives.controller

import com.dotdrives.model.FormReceipt
import com.dotdrives.model.PublicGivingForm

/** Unsaved editor values stay in memory and never become an anonymous draft endpoint. */
fun FormBuilderUiState.donorPreview(orgName: String): PublicGivingForm? {
    val saved = form ?: return null
    return PublicGivingForm(
        id = saved.id,
        orgId = saved.orgId,
        publicSlug = saved.publicSlug,
        orgName = orgName,
        name = draftName,
        headline = draftHeadline,
        version = saved.version,
        config = saved.config.copy(
            amounts = draftAmounts,
            toggles = draftToggles,
            fields = draftFields,
            design = draftDesign,
            story = draftStory,
            employerMatches = draftEmployerMatches,
            receipt = FormReceipt(draftReceiptSubject, draftReceiptMessage, draftIncludeIrsLanguage),
        ),
        paymentsReady = false,
        closeAt = com.dotdrives.model.parseFormCloseAt(draftCloseAt).getOrNull()?.toString(),
        // Neither fee policy nor complete campaign progress is part of the editor snapshot.
        // Keep them absent rather than inventing financial data from the bounded submission feed.
    )
}
